import styled from "styled-components";
import { Box } from "@mui/material";
import Dialog from "@mui/material/Dialog";

export const ManageDataWrapper = styled(Box)`
  font-family: "Noto Sans", sans-serif;
  margin-top: 48px;

  .tabpannel {
      margin-top: 48px;

      button {
          color: #1b4a83;
          font-weight: 600;
          text-transform: none;
          font-family: "Noto Sans", sans-serif;
      }

      button.Mui-selected {
          color: white;
          cursor: pointer;
          font-weight: 600;
          border-radius: 5px;
          background-color: #1b4a83;
          text-transform: none;
          font-family: "Noto Sans", sans-serif;
      }
  }

  .boxWrapper {
      border: 1px solid #1b4a83;
      background-color: #fff;
      border-radius: 0px 0px 5px 5px;
      border-top: 5px solid rgb(27, 74, 131);
      padding: 30px;

      .tabWrapper {
          margin-top: 10px;

          .tableWrapper {
              padding: 0px;

              .buttonTab {
                  padding: 0px;
                  font-family: "Noto Sans", sans-serif;
                  display: block;
                  align-items: center;
                  justify-content: flex-start;
                  padding-bottom: 25px;

                  .css-1gywuxd-MuiInputBase-root-MuiOutlinedInput-root {
                      padding: 0px 0px 0px 8px;
                      font-family: "Noto Sans", sans-serif;
                  }

                  .searchBox {
                      width: 400px;

                      .css-wb57ya-MuiFormControl-root-MuiTextField-root {
                          display: flex;
                      }

                      .searchtextbox {
                          .searchbutton {
                              padding: 6px 25px;
                              color: #1b4a83;
                              background-color: #fff;
                              border-color: #1b4a83;
                              text-transform: capitalize;
                              font-size: 14px;
                              font-family: "Noto Sans", sans-serif;
                          }
                      }
                  }

                  button {
                      width: 105px;
                      padding: 6px 25px;
                      border-color: #1b4a83;
                      background-color: #1b4a83;
                      text-transform: capitalize;
                      font-size: 14px;
                      font-family: "Noto Sans", sans-serif;
                  }

                  align-items: center;
                  padding-bottom: 25px;
              }

              .singlebuttonTab {
                  width: 50%;
                  padding: 0px;
                  font-family: "Noto Sans", sans-serif;
                  display: block;
                  align-items: center;
                  justify-content: flex-start;
                  padding-bottom: 25px;

                  .css-1gywuxd-MuiInputBase-root-MuiOutlinedInput-root {
                      padding: 0px 0px 0px 8px;
                      font-family: "Noto Sans", sans-serif;
                  }

                  button {
                      width: 105px;
                      padding: 6px 25px;
                      border-color: #1b4a83;
                      background-color: #1b4a83;
                      text-transform: capitalize;
                      font-size: 14px;
                      font-family: "Noto Sans", sans-serif;
                  }

                 align-items: center;
                  padding-bottom: 25px;
              }

              div {
                  border-radius: 5px !important;

                  table {
                      border: 1px solid #1b4a83;

                      thead {
                          background-color: #1b4a83;

                          div {
                              display: flex !important;
                              background-color: white;
                          }

                          .fixedColumn {
                              max-width: 120px;
                              min-width: 120px;
                              z-Index: 1;
                              position: sticky;
                              left: 0;
                              background-color: #1b4a83;
                          }

                          .column {
                              max-width: 200px;
                              min-width: 200px;
                          }
                          .componentColumn {
                            max-width: 150px;
                            min-width: 150px;
                        }

                          .checkboxColumns {
                              max-width: 100px;
                              min-width: 100px;
                          }

                          .filterBox {
                              margin-right: 10px;
                          }

                          .filter {
                              width: 100%;
                              padding-left: 5px;
                              font-size: 14px;
                          }

                          tr {
                              th {
                                  font-weight: 600;
                                  color: #fff;
                              }
                          }
                      }

                      .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
                          opacity: 1;
                          color: #fff;
                      }

                      .MuiTableSortLabel-icon {
                          opacity: 1;
                          color: white;
                          font-size: 20px;
                      }

                      tbody {
                          .noquotecell {
                              height: 80px;
                          }

                          .noquotetext {
                              margin-left: 16%;
                              font-weight: 600;
                              font-size:14px;
                              font-family: "Noto Sans", sans-serif;
                          }

                          .boldRow {
                              font-weight: 600;
                          }

                          .freezeRow {

                              position: sticky;
                              left: 0;
                              z-index: 1 !important;
                              background:#fff;;
                          }
                      }
                  }
              }
          }
      }
  }

  .buttondiv {
      display: flex;
      flex-direction: row;
      gap: 20px;
  }

  .uploadedFileName {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      width: 100%;
      border-color: #1b4a83;
      background-color: none;
  }

  .uploadbutton {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      width: 100%;
      border-color: #1b4a83;
      background-color: none;
  }

  .staffDistributionCell {
      minwidth: "150px";
  }

  `;

  export const VisuallyHiddenInput=styled("input")({
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: 1,
      overflow: "hidden",
      position: "absolute",
      bottom: 0,
      left: 0,
      whiteSpace: "nowrap",
      width: 1,
  });

export const DataGridBox=styled(Box)` font-family: "Noto Sans",
sans-serif;
width: 100%;
height: auto;

div {
  border-radius: 0px !important;
}

.grid-header {
  background-color: rgb(27, 74, 131);
  border-radius: 0px !important;
  color: #ffff;
}

.grid-cell {
  border-radius: 0px !important;
}

.css-ptkaw2-MuiDataGrid-root .MuiDataGrid-menuIcon {
  width: auto;
  visibility: visible;
  opacity: 1 !important;

  svg {
      color: #ffff;
      visibility: visible;
      opacity: 1;
  }
}

.css-ptkaw2-MuiDataGrid-root .MuiDataGrid-sortIcon,
.css-ptkaw2-MuiDataGrid-root .MuiDataGrid-filterIcon {
  font-size: inherit;
  color: #ffff;
  visibility: visible;
  opacity: 1;
}

.css-ptkaw2-MuiDataGrid-root .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon {
  color: #ffff;
  visibility: visible;
  opacity: 1;
}

svg {
  color: black;
  visibility: visible;
  opacity: 1;
}

`;

export const PaginationSection=styled(Box)` .paginationContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h6 {
      color: #1b4a83;
      font-weight: 600;
      font-family: "Noto Sans", sans-serif;

      span {
          font-size: 14px;
          font-weight: 500;
          color: #000;
          padding-left: 6px;
          font-family: "Noto Sans", sans-serif;
      }
  }

  button {
      margin: 10px 0;
      border-radius: 2px;
      font-family: "Noto Sans", sans-serif;
  }
}

`;

export const AddUserDialogWrapper=styled(Dialog)` height: 100%;

.customDialogTitle {
  background-color: #1b4a83;
  text-align: center;
  color: #fff;
}

.customDialog {
  text-align: center;
  color: #000;

  img {
      display: block;
      margin: 10px auto;
      /* Center the image horizontally */
      max-width: 100px;
      /* Set the desired max width for the image */
  }

  .note {
      width: 70%;
      text-align: left;
      font-weight: 700;
      padding-left: 20px;
  }

  .customDropdown {
      text-align: left;
      width: 100%;
  }

  span.error {
      color: #d32f2f;
      line-height: 2;
      font-weight: 400;
  }

  span.red {
      color: #ff0000;
  }

  .errorInput {
      border: 1px solid #ff0000;
      border-radius: 5px;
  }

  .field {
      width: 100%;
  }

  .fetchfield {
      width: 50%;
      padding-top: 25px;
  }

  .inputform {
      display: flex;
      width: 100%;
      flex-direction: column;
      padding-top: 30px;
      gap: 25px;
      text-align: start;
      align-items: start;

      .formValue {
          width: 100%;
      }
  }
}

.dialogbutton {
  text-align: center;
  display: flex;
  gap: 40px;
  justify-content: center;
  margin-bottom: 30px;

  .confirmButton {
      text-align: center;
      text-transform: none;
      width: 10%;
  }

  .rightButton {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      width: 10%;
      border-color: #1b4a83;
  }
}

.fetchButton {
  text-align: center;
  text-transform: none;
  width: 100%;
  height: 40px;
  color: #1b4a83;
  border-color: #1b4a83;
}

`;

export const DialogWrapper=styled(Dialog)` height: 100%;

.customDialogTitle {
  background-color: #1b4a83;
  text-align: center;
  color: #fff;
}

.customDialog {
  text-align: start;
  color: #000;
  padding-top: 20px;
}

.dialogbutton {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  .confirmButton {
      text-align: center;
      text-transform: none;
  }

  .rightButton {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      border-color: #1b4a83;
  }
}
}`;